var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TreeFilterDialog',{attrs:{"options":_vm.periodOptions,"isLoading":_vm.isExporting},on:{"onCancel":_vm.onModalCancel,"onConfirm":_vm.onModalConfirm},model:{value:(_vm.modalShown),callback:function ($$v) {_vm.modalShown=$$v},expression:"modalShown"}})
}
var staticRenderFns = []

export { render, staticRenderFns }